import LockPersonOutlined from "@mui/icons-material/LockPersonOutlined";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon";

interface IListStateIconLockedProps {
    locked: boolean
}

export const ListStateIconLocked = (props: IListStateIconLockedProps) => {
    if (!props.locked) return null;
    return (
        <ListStateIcon
            tooltip={Translations.Locked}
            icon={LockPersonOutlined}
            color="warning"
        />
    );
};
